/**
 * VuexPersistence
 * Store persistence plugin, allow data preservation in local storage.
 * https://www.npmjs.com/package/vuex-persist
 */

import VuexPersistence from 'vuex-persist';

export default ({ store }) => {
  new VuexPersistence({
      key: 'ocus-dashboard-image-creator',
      storage: window.localStorage,
      saveState: (key, state, storage) => {
        try {
          storage.setItem(key, JSON.stringify(state));
          return state;
        } catch (error) {
          return error;
        }
      },
      restoreState: (key, storage) => JSON.parse(storage.getItem(key)),
      reducer: (state) => ({
        onboarding: {
          step: state.onboarding.step,
          address: state.onboarding.address,
          phone: state.onboarding.phone,
          skills: state.onboarding.skills,
          memberEquipment: state.onboarding.memberEquipment,
        },
      }),
  }).plugin(store);
};
